import React, { useEffect, useState } from 'react';

import { getSearchLanding } from 'src/services/apiRequests/SearchService';
import { screenViewEvent } from 'src/utils/analytics/mixpanel/mixpanelEventsHelper';
import { getLocalStorage } from 'src/utils/browserStorageHandler';
import { DynamicObject } from 'src/utils/commonTypes';
import { SETTINGS } from 'src/utils/constants/localStorageConstants';
import {
  DisplayLanguage,
  SEARCH_LANDING
} from 'src/utils/constants/stringConstants';
import { ContentMetaData } from 'src/utils/ConsumptionHelper/types';
import {
  MixpanelRailTitle,
  MixpanelRailTypes,
  RailsMixpanelPayload
} from 'src/utils/railsMixpanelPayloadTypes';
import { railsReducer } from 'src/utils/railsReducerHelper/railsReducer';

import { useAppStore } from 'src/hooks/useAppStore';
import { AccumulaterData } from '../SearchTypes';
import { ExploreNow } from './ExploreNow';
import { RenderSearchLandingRails } from './RenderSearchLandingRails';
import {
  getSearchLandingDataFromSessionStorage,
  storeSearchLandingDataToSessionStorage
} from './searchLandingUtils';

interface SearchLandingProps {
  hideMenu: boolean;
}

const SearchLanding = (props: SearchLandingProps) => {
  const { usersLocationData, usersPreferenceData } = useAppStore();
  const conditionConst = {
    EXPLORE: 'explore'
  };
  const [searchLandingData, setSearchLandingData] = useState([]);
  const settings = usersPreferenceData || getLocalStorage(SETTINGS);
  const displayLanguage = settings?.display_language || DisplayLanguage.ENGLISH;
  const contentLanguage = settings?.content_language || DisplayLanguage.ENGLISH;

  const { hideMenu } = props;
  let ScreenViewEventTrigger = false;

  useEffect(() => {
    getSearchLandingData();
  }, []);

  const getSearchLandingData = async () => {
    if (!ScreenViewEventTrigger) {
      screenViewEvent(SEARCH_LANDING);
      ScreenViewEventTrigger = true;
    }
    const obj = {
      city: usersLocationData?.city,
      state: usersLocationData?.state,
      country: usersLocationData?.country,
      displayLanguage: displayLanguage,
      contentLanguage: contentLanguage
    };
    const sessionStorageData = getSearchLandingDataFromSessionStorage();
    if (sessionStorageData?.length) {
      setSearchLandingData(sessionStorageData);
    } else {
      const response = await getSearchLanding(obj);
      if (response?.searchLanding?.length) {
        const { searchLanding } = response;
        storeSearchLandingDataToSessionStorage(searchLanding);
        setSearchLandingData(searchLanding);
      }
    }
  };

  const generateMixpanelPayload = (
    contents: DynamicObject | undefined,
    carouselTitle: string,
    verticalIndex: number,
    railIDsAndRailElements?: AccumulaterData
  ): RailsMixpanelPayload => {
    return {
      trayDetails: {
        allCollectionsResolved: false,
        index: verticalIndex + 1,
        isEpisodeConsumption: false, // replace with thumbnailType
        isPendingResolved: true,
        isRecommendedColumn: false,
        pendingDataAvailable: false,
        title: MixpanelRailTitle.SEARCH_LANDING,
        tabName: '',
        talamoosModelName: '',
        type: MixpanelRailTypes.SIMILAR,
        carouselTitle
      },
      trayData: {
        content: contents?.map((content: DynamicObject) => ({
          title: content?.title,
          value: content?.title
        })),
        partnerDetails: {
          content_partner_id: usersPreferenceData?.partner
            ?.partner_id as number,
          content_partner_name: usersPreferenceData?.partner
            ?.partner_name as string
        }
      },
      railIDs: railIDsAndRailElements?.railIDs,
      railElements: railIDsAndRailElements?.railElements,
      activeSubscriptions: []
    };
  };

  const displayCards = (content: ContentMetaData, index: number) => {
    const railIDsAndRailElements = railsReducer(content);
    const constainsExploreNow = content?.tags?.includes(conditionConst.EXPLORE);

    if (constainsExploreNow) {
      return (
        <ExploreNow
          data={content?.contents}
          hideMenu={hideMenu}
          content={content}
          isSearchLanding={true}
          verticalIndex={index}
          mixpanelPayload={
            generateMixpanelPayload(
              content?.contents,
              content?.title,
              index,
              railIDsAndRailElements
            ) as RailsMixpanelPayload
          }
        />
      );
    } else {
      return <RenderSearchLandingRails content={content} index={index} />;
    }
  };

  return (
    <div>
      {searchLandingData?.length
        ? searchLandingData?.map((content: ContentMetaData, index: number) => {
            return (
              <React.Fragment key={index}>
                {displayCards(content, index)}
              </React.Fragment>
            );
          })
        : null}
    </div>
  );
};

export default SearchLanding;
